const validation = {
  phoneNumber: {
    presence: {
      message: '^validation.account.enterPhoneNumber'
    }
  },
};

export default validation;
